import { call, put, takeEvery } from 'redux-saga/effects';
import { get, keyBy, values, merge } from 'lodash-es';
import { fetchfundsInfo, trigger_investment } from '../../apis/mfOrders';
import { getfundOrderDetails, setFundOrderDetails, triggerInvestment } from '../reducers/mfOrders';
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import { getFundLogoAndIsin } from '../../utils/mfOrder/functions';

export default function* handleDiySagas() {
  yield takeEvery(getfundOrderDetails.toString(), handleFetchSipLumpsumOrderDetails);
  yield takeEvery(triggerInvestment.toString(), handleFetchInvestmentData);
}

function* handleFetchSipLumpsumOrderDetails({ payload }) {
  const { Api, fundsData, isins, token, screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const sipDetails = yield call(fetchfundsInfo, Api, 'sip', isins, token);
    const sipFundsData = get(sipDetails, 'funds_data', []);
    const fundSipFullDetails = sipFundsData.map((el) => {
      return {
        ...el,
        addl_purchase: {
          sip: el.addl_purchase || {},
        },
        sip_allowed: el.ot_sip_flag
      };
    });
    const fundLogoAndIsin = getFundLogoAndIsin(fundsData)
    const lumpsumDetails = yield call(fetchfundsInfo, Api, 'onetime', isins, token);
    const lumpsumFundsData = get(lumpsumDetails, 'funds_data', []);
    const fundLumpsumFullDetails = lumpsumFundsData.map((el) => {
      return {
        ...el,
        addl_purchase: {
          lumpsum: el.addl_purchase || {},
        },
        lumpsum_allowed: el.ot_sip_flag
      };
    });
    const mergeSipLumpsumData = merge( keyBy(fundSipFullDetails, 'isin'),keyBy(fundLumpsumFullDetails, 'isin'), keyBy(fundLogoAndIsin, 'isin'));
    yield put(setFundOrderDetails(values(mergeSipLumpsumData)));
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchInvestmentData({ payload }) {
  const { Api, screen, body, token, sagaCallback } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const response = yield call(trigger_investment, Api, body, token);
		yield call(sagaCallback, response);
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}
